import React from "react";
import ProjectLanguages from "../../components/projectLanguages/ProjectLanguages";
import "./GithubRepoCard.css";
import { Fade } from "react-reveal";

export default function GithubRepoCard({ repo, theme }) {
  const createdYear = repo.createdAt ? repo.createdAt.split("-")[0] : "";

  function openRepoinNewTab(url) {
    var win = window.open(url, "_blank");
    win.focus();
  }

  return (
    <Fade bottom duration={1200} distance="24px">
      <article
        className="repo-card-div"
        onClick={() => openRepoinNewTab(repo.url)}
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            openRepoinNewTab(repo.url);
          }
        }}
        role="link"
        tabIndex="0"
        aria-label={`Open ${repo.name} on GitHub`}
      >
        <div className="repo-card-top">
          <span className="repo-type-label">Project</span>
          {createdYear && <span className="repo-year">{createdYear}</span>}
        </div>
        <div className="repo-name-div">
          <span className="repo-icon" aria-hidden="true">
            <i className="fas fa-code-branch"></i>
          </span>
          <h2 className="repo-name" style={{ color: theme.text }}>
            {repo.name}
          </h2>
        </div>
        <p className="repo-description" style={{ color: theme.text }}>
            {repo.description}
        </p>
        <div className="repo-details">
          <ProjectLanguages className="repo-languages" logos={repo.languages} />
          <span className="repo-open-action">
            Open <i className="fas fa-arrow-right" aria-hidden="true"></i>
          </span>
        </div>
      </article>
    </Fade>
  );
}
